
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.816 7.172l-2.15-.127C3.208 3.087 7.632.833 11.945 1.954c4.594 1.194 7.323 5.764 6.095 10.208-1.015 3.675-4.42 6.114-8.166 6.171","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 18.333c-4.583 0-8.333-4.166-8.333-9.166","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","stroke-dasharray":"0.5 3"}}),_c('path',{attrs:{"d":"M11.337 8.102c-.293-.308-1.011-1.03-2.146-.518-1.134.513-1.315 2.164.401 2.34.776.079 1.282-.092 1.745.392.463.485.549 1.832-.635 2.195-1.183.363-1.95-.237-2.157-.424m1.378-5.404v.66m0 5.28v.727","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    